import { ReactNode, memo } from 'react';
import {
  Table,
  TableCell,
  TableHeadCell,
  TableRow,
} from './LayoutTable.styles';

export type ID = string | number;

function LayoutTablePureComponent({
  body,
  head,
}: {
  body: { id: ID; values: Map<ID, ReactNode> }[] | undefined;
  head: { id: ID; label: ReactNode }[] | undefined;
}) {
  return (
    <Table>
      <thead>
        <tr>
          {head &&
            head.map(({ id, label }) => (
              <TableHeadCell key={id}>{label}</TableHeadCell>
            ))}
        </tr>
      </thead>
      <tbody>
        {body &&
          body.map(({ id, values }) => (
            <TableRow key={id}>
              {head &&
                head.map((column) => (
                  <TableCell key={column.id}>{values.get(column.id)}</TableCell>
                ))}
            </TableRow>
          ))}
      </tbody>
    </Table>
  );
}

export const LayoutTable = memo(LayoutTablePureComponent);
